import { render, staticRenderFns } from "./reserve-select-people.vue?vue&type=template&id=d6dae7f0&scoped=true&lang=pug"
import script from "./reserve-select-people.vue?vue&type=script&lang=js"
export * from "./reserve-select-people.vue?vue&type=script&lang=js"
import style0 from "./reserve-select-people.vue?vue&type=style&index=0&id=d6dae7f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dae7f0",
  null
  
)

export default component.exports